
export default {
    data() {
        return {
            nav:0,
            source:'',
            currentPage:1,
            video: 1,
        }
    },
}
